import ClHomepage from 'pages/clientPage/homepage';
import AdHomepage from 'pages/adminPage/homepage';
import AdRouteOutlet from 'components/adminComp/routeOutlet';
import AdLoginPage from 'pages/adminPage/login';
import ClPageNotFound from 'pages/clientPage/pageNotFound';

export const clientRoutes = [
  {
    path: '/',
    module: <ClHomepage />,
  },
  {
    path: '/login',
    module: <AdLoginPage />,
  },
  {
    path: '*',
    module: <ClPageNotFound />,
  },
];

export const adminRoutes = {
  path: '/admin',
  module: <AdRouteOutlet />,
  isPrivate: true,
  children: [
    {
      module: <AdHomepage />,
    },
    {
      module: <AdHomepage />,
      path: '',
    },
  ],
};
